import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';  
import { BehaviorSubject, map, Observable, of, tap } from 'rxjs';
import { Api, ApiAuth } from 'app/domain/api';
import { ApiResponse } from 'app/domain/auth.model';
import { CustomerDTO } from 'app/domain/api.model';


@Injectable({providedIn: 'root'})
export class CustomerService  { 

  constructor(private http: HttpClient) { }

  
  // private _customers: BehaviorSubject<CustomerDTO[] | null> = new BehaviorSubject(null);
  
  // get customers$(): Observable<CustomerDTO[]> {
  //   return this._customers.asObservable();
  // }

  // getAll(): Observable<CustomerDTO[]> {
  //   return this.http.get<CustomerDTO[]>(Api.Customers).pipe(
  //       tap((users) => {
  //           this._customers.next(users);
  //       })
  //   );
  // } 

  private _customers: BehaviorSubject<CustomerDTO[] | null> = new BehaviorSubject<CustomerDTO[] | null>(null);
  
  get customers$(): Observable<CustomerDTO[] | null> {
    return this._customers.asObservable();
  }
 
  getAll(): Observable<CustomerDTO[]> {
        return this.http.get<CustomerDTO[]>(Api.Customers).pipe(
          map(customers => 
            // Sort logic: (a, b) comparison
            customers.sort((a, b) => {
  const snA = a?.surname ?? '';
  const snB = b?.surname ?? '';
  return snA.localeCompare(snB);
})
          ),
          tap((sorted) => {
            this._customers.next(sorted);
          })
        );
      }









  private _customer: BehaviorSubject<CustomerDTO | null> = new BehaviorSubject<CustomerDTO | null>(null);
  
  get customer$(): Observable<CustomerDTO | null> {
    return this._customer.asObservable();
  }

  get(code : string): Observable<CustomerDTO> {
    return this.http.get<CustomerDTO>(Api.Customer + '/get/' + code).pipe(
        tap((customer) => {
            this._customer.next(customer);
        })
    );
  } 

 

  public delete(code : String) : Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(Api.Customer + "/" + code);
  }


  public load() : Observable<CustomerDTO[]> {
    return this.http.get<CustomerDTO[]>(Api.Customer);
  }

  public loadByMaster(masterCode : string) : Observable<CustomerDTO[]> {
    return this.http.get<CustomerDTO[]>(Api.Customer + "/master/" + masterCode);
  }


  public save(dto : CustomerDTO) : Observable<ApiResponse> {
    if(!dto.code)
      return this.http.post<ApiResponse>(Api.Customer, dto);
    else
      return this.http.put<ApiResponse>(Api.Customer, dto);
  }

  public setMaster(code : string) : Observable<ApiResponse> {
      return this.http.post<ApiResponse>(Api.Customer +"/master/" + code, {});
  }

  public detach(code : string) : Observable<ApiResponse> {
    return this.http.post<ApiResponse>(Api.Customer +"/detach/" + code, {});
  }

  public merge(master : string, child : string) : Observable<ApiResponse> {
    return this.http.post<ApiResponse>(Api.Customer +"/merge/" + master + "/" + child, {});
  }


  public toogleConfirm(code : string, confirmed : boolean) : Observable<ApiResponse> {
    if(!confirmed)
      return this.http.put<ApiResponse>(Api.Customer +"/confirm/" + code, {});
    else
      return this.http.put<ApiResponse>(Api.Customer +"/unconfirm/" + code, {});
  }




  private _customerLogged: BehaviorSubject<CustomerDTO | null> = new BehaviorSubject<CustomerDTO | null>(null);
  
  get customerLogged$(): Observable<CustomerDTO | null> {
    return this._customerLogged.asObservable();
  }

  getLogged(): Observable<CustomerDTO> {
    return this.http.get<CustomerDTO>(Api.Customer + '/current').pipe(
        tap((customerLogged) => {
            this._customerLogged.next(customerLogged);
        })
    );
  } 
 
}
